module.exports = __webpack_public_path__ + "static/media/BigStar.1099f41b.svg";